import script from "./AdminReportsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminReportsModal.vue?vue&type=script&setup=true&lang=js"

import "./AdminReportsModal.vue?vue&type=style&index=0&id=548ad6e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-548ad6e2"]])

export default __exports__